// extracted by mini-css-extract-plugin
export var container = "style-module--container--07edc";
export var desc = "style-module--desc--29411";
export var form = "style-module--form--1fbad";
export var info = "style-module--info--12f2a";
export var neuro = "style-module--neuro--02cce";
export var policy = "style-module--policy--e4fe5";
export var sub = "style-module--sub--31267";